import React from "react";

const FiltresFormation = ({ annonces, filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newFilters = { ...filters };

    if (type === "checkbox") {
      newFilters[name] = checked
        ? [...(filters[name] || []), value]
        : filters[name].filter((v) => v !== value);
    } else {
      newFilters[name] = value;
    }

    onChange(newFilters);
  };

  const uniqueSecteurs = [...new Set(annonces.map((a) => a.secteur).filter(Boolean))];

  return (
    <div>
      <h3>Secteur d'activité</h3>
      {uniqueSecteurs.map((secteur) => (
        <label key={secteur}>
          <input
            type="checkbox"
            name="secteur"
            value={secteur}
            onChange={handleChange}
          />
          {secteur}
        </label>
      ))}

      <h3>Prix</h3>
      <label>
        Min:
        <input
          type="number"
          name="prixMin"
          value={filters.prixMin}
          onChange={handleChange}
          placeholder="Prix minimum"
        />
      </label>
      <label>
        Max:
        <input
          type="number"
          name="prixMax"
          value={filters.prixMax}
          onChange={handleChange}
          placeholder="Prix maximum"
        />
      </label>
    </div>
  );
};

export default FiltresFormation;
